// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminExecutionControlPlane = {
  controlPlaneFields: {
    activeWorkers: "Active workers",
    controlPlaneState: "Control-plane state",
    criticalAlerts: "Critical alerts",
    warningAlerts: "Warning alerts",
    redis: "Redis scheduling",
    pendingOldest: "Oldest pending",
    runningOldest: "Oldest running",
    leaseRisk: "Lease risk",
    cancelRequested: "Cancel requested",
    pendingWorkers: "Dispatch workers",
    retryWorkers: "Retry workers",
    recoveryWorkers: "Recovery workers",
    cleanupWorkers: "Cleanup workers",
    recentEventWindow: "Stats window",
    recentClaimConflicted: "Recent claim conflicts",
    recentRateLimited: "Recent rate-limited blocks",
    recentCapabilityMismatched: "Recent capability mismatches",
    recentDispatchFailed: "Recent dispatch failures",
    capabilityBlockedActions: "Capability-blocked actions",
    workerPolicyCoverage: "Worker policy coverage",
    workerPolicies: "Worker policies",
    remediation: "Remediation",
    actionBacklog: "Action backlog",
  },
  remediationFields: {
    triggerShort: "trigger {value}",
    capabilityShort: "capability {value}",
  },
  remediationPriorities: {
    warning: "Warning",
    critical: "Critical",
  },
  remediationActions: {
    bring_up_stale_running_recovery_worker: "Bring up stale recovery worker",
    bring_up_failed_cleanup_worker: "Bring up failed cleanup worker",
    bring_up_auto_retry_worker: "Bring up auto-retry worker",
    bring_up_dispatch_worker: "Bring up dispatch worker",
    add_capable_worker: "Add capable worker",
    increase_running_limit_or_scale_workers: "Raise running limit or scale workers",
    increase_pending_limit_or_reduce_submit_rate: "Raise pending limit or reduce submit rate",
    investigate_dispatch_failures: "Investigate dispatch failures",
    drain_retryable_failed_backlog: "Drain retryable failed backlog",
    reduce_claim_contention: "Reduce claim contention",
    rebalance_capacity_or_submission_rate: "Rebalance capacity or submission rate",
    align_worker_capabilities: "Align worker capabilities",
    drain_aged_backlog: "Drain aged backlog",
  },
  remediationReasons: {
    missing_worker_policy_coverage: "Missing worker policy coverage",
    missing_capable_worker: "Missing capable worker",
    running_limit_reached: "Running limit reached",
    pending_limit_reached: "Pending limit reached",
    recent_dispatch_failed: "Recent dispatch failures",
    retry_pressure: "Retry pressure",
    claim_conflicted: "Claim conflicted",
    rate_limited: "Rate limited",
    capability_mismatched: "Capability mismatched",
    queue_aging: "Queue aging",
  },
  workerPolicy: {
    covered: "covered {count}",
    missing: "missing {count}",
    coverageSummary: "Background processing coverage: {covered} / {total}",
    noActiveWorkers: "No active worker available",
    currentState: "Current state: {value}",
    impact: "Impact: {value}",
    capabilityWithCount: "{label} ({count})",
    capabilities: {
      pendingDispatch: "Task dispatch",
      autoRetry: "Automatic retry",
      staleRunningRecovery: "Stale-task recovery",
      failedCleanup: "Failed-instance cleanup",
    },
    impacts: {
      pendingDispatch: "New tasks will not be dispatched automatically",
      autoRetry: "Retryable tasks will not be rescheduled automatically",
      staleRunningRecovery: "Stale running tasks will not enter automatic recovery",
      failedCleanup: "Failed instances will not be cleaned up automatically",
      unknown: "This processing capability is currently not covered",
    },
  },
  actionBacklog: {
    currentState: "Current state: {value}",
    workerCoverage: "Capable workers: {count}",
    capacity: "Running {running}/{runningLimit} · Pending {pending}/{pendingLimit}",
    impacts: {
      capabilityBlocked: "No worker is currently able to execute this action",
      dispatchFailed: "This action recently had dispatch failures and needs investigation",
      retryPending: "This action has tasks waiting for automatic retry",
      queuePressure: "This action is under queue pressure",
      normal: "This action is currently stable",
    },
  },
  alertStates: {
    normal: "Normal",
    warning: "Warning",
    critical: "Critical",
  },
  backlogStates: {
    normal: "Normal",
    warning: "Warning",
    saturated: "Saturated",
  },
  backlogMetrics: {
    claimConflictedShort: "conflict {count}",
    rateLimitedShort: "rate {count}",
    capabilityMismatchedShort: "cap {count}",
    dispatchFailedShort: "dispatch {count}",
    retryableFailedShort: "retryable {count}",
    autoRetryScheduledShort: "retry-pending {count}",
    pendingAgeShort: "pending-age {count}s",
    runningAgeShort: "running-age {count}s",
  },
} as const;
